// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/rootIn-F.jpg";
import thumb1 from "../assets/images/New-Products/rootIn.jpg";
import thumb2 from "../assets/images/New-Products/rootIn-F.jpg";
import thumb3 from "../assets/images/All-Products/rootINF.png";
// import videoThumb from "../assets/images/skin breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/hair-breadcrum.jpg";
import howToUseThumb from "../assets/images/hair-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Transforming Hair Health Through Scientific Innovation."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Hair Care", to: "/HairCareProducts" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb2, thumb3].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Root IN F</h2>
              <p className="sub-heading">Minoxidil and Finasteride synergy for Hair Growth</p>
              <h5>Product Overview</h5>
              <p>
                Root in -F Solution is a combination medicine used in the treatment of hair loss.
                It works by increasing blood flow to the hair follicles which further prevents hair loss and stimulates re-growth resulting in longer, thicker and increased numbers of hair.
                Root In – F Solution should only be applied directly to the scalp area in the amount, and in the way, specified on the label or by your doctor.
                Clean and dry your scalp before using it. It may take several months before you notice any hair growth and the first growth may be soft, colourless and barely visible.
                Using more than recommended will not speed up hair growth and may cause dangerous side effects. This medication must be used continuously to maintain hair growth.
                If your condition does not improve or worsens after using it for 4 to 6 months, tell your doctor.
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Root IN F?</span>
                </h3>
                <p>
                  Use this medicine in the dose and duration as advised by your doctor. Check the label for directions before use.
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <p><strong>1. Benefits</strong></p>
                  {/* <ul>
                    <li>Root In 5% Solution is a serum used to treat common hereditary hair loss.</li>
                    <li>It can prevent further hair loss and help hair to re-grow.</li>
                    <li>It works by increasing blood flow to the hair follicles on your scalp, which prevents hair cell death and also enhances new hair growth.</li>
                    <li>It is most effective for baldness or thinning at the top of the scalp but less effective at the front or for a receding hairline.</li>
                    <li>Benefits are less likely if you have been bald for many years or have a large area of hair loss.</li>
                    <li>Root In 5% Solution is not suitable for sudden or unexplained hair loss.</li>
                    <li>It is considered a safe medicine. However, hair that has re-grown may disappear after a few months.</li>
                    <li>Re-growth of hair can be beneficial to your mood, self-esteem, and appearance — but you need to use it regularly to get the benefits.</li>
                    <li>There are separate products available for men and women.</li>
                  </ul> */}

                  <ol>
                    <li>Combines two clinically proven actives to stimulate growth and control hair loss at the root.</li>
                    <li>Helps reduce DHT-related follicle shrinkage, a key reason behind pattern hair loss.</li>
                    <li>Supports the transition of inactive follicles into the active growth (anagen) phase.</li>
                    <li>Works progressively to minimize shedding and stabilize hair loss.</li>
                    <li>Improves blood flow → better nutrient and oxygen supply to follicles.</li>
                    <li>Helps maintain healthy hair growth cycle with continued use.</li>
                    <li>Non-greasy serum base ensures better absorption and daily comfort.</li>
                  </ol>

                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Towel dry your hair.</li>
                      <li>Part your hair and spray 1 ml (4–5 sprays) on affected areas of the scalp.</li>
                      <li>Maximum dose – 2 ml per day.</li>
                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>

                    <ul>
                      <li> Hair loss, especially pattern hair loss, is driven by two key factors—reduced blood supply to hair follicles and the effect of DHT (Dihydrotestosterone), which weakens and shrinks follicles over time.</li>
                      <li>
                        <strong>Minoxidil (5% w/v):</strong> Minoxidil + Finasteride Serum is an advanced, clinically backed formulation that works through a dual-action approach—stimulating hair growth while targeting the root hormonal cause of hair thinning.
                      </li>

                      <li>
                        <strong>Procapil:</strong>
                        <ul>
                          <li>
                            <strong>Biotinoyl Tripeptide-1:</strong> A cosmetic ingredient used in hair care formulations.
                            It promotes hair growth by inhibiting 5-alpha reductase types 1 and 2, which convert testosterone to dihydrotestosterone (DHT)—a major factor in hair loss.
                            It also enhances the proliferation of hair bulb keratinocytes, supporting hair conditioning and improving hair density and scalp health.
                          </li>
                          <li>
                            <strong>Apigenin:</strong> A flavonoid abundant in chamomile flowers (about 68% of the total flavonoid content).
                            It stimulates microcirculation, improving blood flow to the scalp, and downregulates the TGF-beta 1 gene, which suppresses hair growth.
                            Apigenin also provides antioxidant and anti-inflammatory benefits, protecting the scalp from oxidative stress and inflammation.
                          </li>
                          <li>
                            <strong>Oleanolic Acid:</strong> A naturally occurring pentacyclic triterpenoid known for promoting hair matrix cell proliferation and improving cellular metabolism.
                            It supports healthier, more robust hair growth and also has hepatoprotective properties, helping protect the liver from damage.
                          </li>
                        </ul>
                      </li>

                      <li>
                        <strong>Finasteride (0.1% w/v):</strong> Finasteride is a 5-alpha-reductase inhibitor that blocks the production of a male hormone in the scalp responsible for hair loss.
                        It reverses the balding process and prevents further hair loss by competitively inhibiting 5α-reductase type 2, reducing the conversion of testosterone to DHT and markedly suppressing serum DHT levels.
                      </li>
                    </ul>

                  </p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
